module.exports = function() {
  return new Worker(__webpack_public_path__ + "2b8615daeba111b194e8.worker.js");
};